// extracted by mini-css-extract-plugin
module.exports = {"header":"SideSheetRight_header__4kLvw","headerBackArrow":"SideSheetRight_headerBackArrow__6rJ7k","body":"SideSheetRight_body__ct5M9"};